export enum Priorities {
  Low = 'low',
  Medium = 'medium',
  High = 'high',
}
